import { css } from "@emotion/react";
import { SwarovskiOptikLocaleFrontend } from "@swo/storefront";
import React from "react";
import { PDPState } from "../availability/use-product-variant-state";
import { PDPAction } from "../state/types";
import { getMultiselect } from "./get-multiselect-data";
import { PDPPicker } from "./PickerLayoutComponent";
import { useCtxFns } from "../../../../global/page-context";

export const ProductVariantPickerLayoutComponent: React.FC<{
  localeLanguageEnglishName: string;
  pdpState: PDPState;
  dispatch: React.Dispatch<PDPAction>;
}> = ({
  pdpState: { computed, selectedProduct, attributesSelection, linkForClickedAttribute },
  dispatch,
  localeLanguageEnglishName,
}) => {
  const { showPrice } = useCtxFns();

  if (!computed.multiselects) {
    return null;
  }

  const getMultiselectData = getMultiselect(
    selectedProduct,
    attributesSelection,
    linkForClickedAttribute,
    computed.multiselects,
    dispatch,
    showPrice,
  );

  return (
    <div
      className="u-flex u-flex-col"
      css={css`
        gap: 20px;
      `}
    >
      {computed.multiselects
        .map((m, idx) => getMultiselectData(m, idx))
        .map(multiselectData => {
          return (
            <div
              key={`${selectedProduct.key}-${multiselectData.reactKey}`}
              className={`js-${multiselectData.headline.toLowerCase()}`}
            >
              <PDPPicker
                headline={multiselectData.headline}
                disabled={multiselectData.disabled}
                attributes={multiselectData.extendedAttributesForPicker}
                languageName={localeLanguageEnglishName}
                selectedProduct={selectedProduct}
                onPDPActionClick={dispatch}
              />
            </div>
          );
        })}
    </div>
  );
};
